import { initialState as initialSessionUser } from './reducers/sessionUserReducer'
export const initialState = { sessionUser: initialSessionUser }
